import {IntlShape} from 'react-intl';

export const statusColorMap = new Map<string, string>([
    ['Nouveau', '#5b70b0'],
    ['Pris en charge', '#de8100'],
    ['Fermé avec succés', '#5da170'],
    ['Fermé sans succés', '#c44d4d'],
    ['Supprimé', '#ababab'],
    ['En attente', '#e6c84a'],
    ['Attente de fermeture auto', '#e6c84a'],
    ['Fusionné', '#e0e0e0'],
    ['En escalade', '#c44d4d'],
    ['', '#5b70b0'],
    ['En cours', '#de8100'],
    ['light', '#e0e0e0'],
    ['Gelé', '#e0e0e0'],
    ['Rétabli', '#5da170'],
]);

export const getStatusColor = (status: string | null): string => {
    return status === null
        ? '#888'
        : statusColorMap.get(status) || '#888';
};

const LIGHT_BACKGROUNDS = new Set(['#e6c84a', '#e0e0e0', '#ababab']);

export const getStatusTextColor = (backgroundColor: string): string =>
    LIGHT_BACKGROUNDS.has(backgroundColor.toLowerCase()) ? '#333' : '#fff';

const statusLabelKeyMap = new Map<string, string>([
    ['Nouveau', 'DASHBOARD.TICKETS.STATUS.NEW'],
    ['Pris en charge', 'TICKET.STATE.TAKEN_IN_CHARGE'],
    ['Fermé avec succés', 'TICKET.STATE.CLOSED_SUCCESS'],
    ['Fermé sans succés', 'TICKET.STATE.CLOSED_FAILURE'],
    ['Supprimé', 'TICKET.STATE.DELETED'],
    ['En attente', 'TICKET.STATE.WAITING'],
    ['Attente de fermeture auto', 'TICKET.STATE.WAITING_AUTO_CLOSE'],
    ['Fusionné', 'TICKET.STATE.MERGED'],
    ['En escalade', 'TICKET.STATE.ESCALATED'],
    ['En cours', 'DASHBOARD.TICKETS.STATUS.IN_PROGRESS'],
    ['Gelé', 'TICKET.STATE.FROZEN'],
    ['Rétabli', 'TICKET.STATE.RESTORED'],
]);

export const getStatusLabel = (status: string | null, intl: IntlShape): string => {
    const trimmed = (status ?? '').trim();
    if (trimmed === '') {
        return intl.formatMessage({id: 'DASHBOARD.TICKETS.STATUS.IN_PROGRESS'});
    }
    const messageId = statusLabelKeyMap.get(trimmed);
    return messageId ? intl.formatMessage({id: messageId}) : trimmed;
};
